module.exports = __webpack_public_path__ + "static/media/cheering_people_icon1.049804ed.png";